const STATIC_BASE = process.env.REACT_APP_BACKEND_URL;

/**
 * Единый резолвер URL изображений/видео из API.
 *
 * Бэкенд отдаёт либо абсолютный URL (R2 CDN), либо относительный путь
 * вида "/api/r2/..." / "/api/static/...". В браузере относительный путь
 * работает (тот же origin), но в нативной сборке Capacitor origin —
 * capacitor://localhost, и такой путь уходит в локальный бандл.
 * Поэтому относительные пути всегда префиксуем REACT_APP_BACKEND_URL.
 *
 * opts.w — ширина превью для нашего R2-прокси (?w=NNN).
 */
export function resolveImageUrl(src, opts) {
  if (!src) return "";
  const w = opts && opts.w;
  const withThumb = (u) => {
    if (!w) return u;
    // ?w= понимает только наш прокси — внешние CDN пропускаем как есть.
    if (u.includes("/api/r2/")) {
      return u + (u.includes("?") ? "&" : "?") + "w=" + w;
    }
    return u;
  };
  if (/^https?:\/\//i.test(src)) return withThumb(src);
  if (src.startsWith("blob:") || src.startsWith("data:")) return src;
  if (src.startsWith("/")) return withThumb(`${STATIC_BASE}${src}`);
  return src;
}

export default resolveImageUrl;
